import {IRound} from "data/types/entities";
import {FINALS_ROUND_START, GREY_CUP_ROUND_NUMBER} from "data/constants";

export abstract class RoundUtils {
	static isFinalRound(round: IRound) {
		return round.number >= FINALS_ROUND_START;
	}

	static isGrayCupRound(round: IRound) {
		return round.number >= GREY_CUP_ROUND_NUMBER;
	}
}
